import { validationMixin } from 'vuelidate'
export default {
  mixins: [validationMixin],
  data() {
    return {
      invalid: false,
      error: null,
    }
  },

  computed: {
    errorMessageId() {
      return this.invalid ? 'field-error-' + this.id : false
    },
  },
}
